module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("2XoTD"))).then(() => parcelRequire('cSK4t'));